import PageMetaTags from "components/PageMetaTags"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import {
  Card,
  CardBody,
  Col,
  Container,
  Nav,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"
import {
  getAllEventsCalendar,
  getBusinessUnits,
  getEventsCalendar,
} from "store/actions"
import ManageEventsTab from "./manageEventsTab"
import ScheduledEventsTab from "./scheduledEventsTab"

const EventsCalendar = ({
  getBusinessUnits,
  getEventsCalendar,
  getAllEventsCalendar,
}) => {
  const TABS = {
    SCHEDULED_EVENTS: 1,
    MANAGE_EVENTS: 2,
  }

  const [activeTab, setActiveTab] = useState(TABS.SCHEDULED_EVENTS)

  const markIfIsActive = tab => {
    return activeTab === tab ? "active" : ""
  }

  useEffect(() => {
    getEventsCalendar({ type: 1 })
    getBusinessUnits()
    getAllEventsCalendar({ type: 1 })
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <PageMetaTags title="Events" />
        <Container fluid>
          <Card>
            <CardBody>
              <Row>
                <Col>
                  <Nav pills tabs>
                    <NavLink
                      className={markIfIsActive(TABS.SCHEDULED_EVENTS)}
                      onClick={() => setActiveTab(TABS.SCHEDULED_EVENTS)}
                    >
                      <span style={{ fontSize: "16px" }}>Scheduled Events</span>
                    </NavLink>
                    <NavLink
                      className={markIfIsActive(TABS.MANAGE_EVENTS)}
                      onClick={() => setActiveTab(TABS.MANAGE_EVENTS)}
                    >
                      <span style={{ fontSize: "16px" }}>
                        Manage Event Calendars
                      </span>
                    </NavLink>
                  </Nav>
                  <TabContent activeTab={activeTab}>
                    <TabPane tabId={TABS.SCHEDULED_EVENTS}>
                      <ScheduledEventsTab
                        tabIsActive={activeTab === TABS.SCHEDULED_EVENTS}
                      />
                    </TabPane>
                    <TabPane tabId={TABS.MANAGE_EVENTS}>
                      <ManageEventsTab
                        tabIsActive={activeTab === TABS.MANAGE_EVENTS}
                      />
                    </TabPane>
                  </TabContent>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({})

const mapDispatchToProps = dispatch => ({
  getBusinessUnits: values => dispatch(getBusinessUnits(values)),
  getEventsCalendar: values => dispatch(getEventsCalendar(values)),
  getAllEventsCalendar: values => dispatch(getAllEventsCalendar(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(EventsCalendar)
